export const LOW_STOCK_THRESHOLD = 3;

export const getStockStatus = (stock) => {
  if (stock <= 0) {
    return 'Out of stock';
  }

  if (stock <= LOW_STOCK_THRESHOLD) {
    return 'Low stock';
  }

  return 'Available';
};

export const getStockBadgeClassName = (stock) => {
  if (stock <= 0) {
    return 'bg-red-100 text-red-800';
  }

  if (stock <= LOW_STOCK_THRESHOLD) {
    return 'bg-amber-100 text-amber-800';
  }

  return 'bg-green-100 text-green-800';
};

export const getServiceDeskOptions = (stocks) => {
  const desksMap = new Map();

  stocks.forEach((stock) => {
    if (!desksMap.has(stock.serviceDeskId)) {
      desksMap.set(stock.serviceDeskId, {
        id: String(stock.serviceDeskId),
        name: stock.serviceDeskName,
      });
    }
  });

  return Array.from(desksMap.values());
};

export const getProviderOptions = (stocks) => {
  const providersMap = new Map();

  stocks.forEach((stock) => {
    if (!providersMap.has(stock.provider)) {
      providersMap.set(stock.provider, {
        id: stock.provider,
        label: stock.providerLabel,
      });
    }
  });

  return Array.from(providersMap.values());
};

export const getStocksStats = (stocks) => {
  const lowStock = stocks.filter(
    (stock) => stock.stock > 0 && stock.stock <= LOW_STOCK_THRESHOLD
  ).length;

  return {
    total: stocks.length,
    lowStock,
    outOfStock: stocks.filter((stock) => stock.stock <= 0).length,
    serviceDeskCount: new Set(stocks.map((stock) => stock.serviceDeskId)).size,
  };
};
